 
/* ================================
   Firebase + Firestore (CDN)
   ================================ */
(function () {

  // 1️⃣ Load Firebase scripts dynamically (Shopify-safe)
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  Promise.all([
    loadScript("https://www.gstatic.com/firebasejs/9.23.0/firebase-app-compat.js"),
    loadScript("https://www.gstatic.com/firebasejs/9.23.0/firebase-firestore-compat.js")
  ]).then(initFirestore);

  function initFirestore() {

    /* ================================
       2️⃣ Firebase config
       ================================ */
    var firebaseConfig = {
      apiKey: "AIzaSyANYozYWioBP5nQb6UzCR9Voq6TZF3tHpk",
      authDomain: "bv-uk-search-terms.firebaseapp.com",
      projectId: "bv-uk-search-terms",
      storageBucket: "bv-uk-search-terms.firebasestorage.app",
      messagingSenderId: "432015201717",
      appId: "1:432015201717:web:44593870cf7de9ef22f5fc",
      measurementId: "G-XX3K04TRMB"
    };

    firebase.initializeApp(firebaseConfig);
    var db = firebase.firestore();

    /* ================================
       3️⃣ Debounce helper
       ================================ */
    function debounce(fn, delay) {
      var timer;
      return function () {
        var args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(null, args);
        }, delay || 600);
      };
    }

    /* ================================
       4️⃣ Session ID
       ================================ */
    var sessionId = sessionStorage.getItem("search_session_id");
    if (!sessionId) {
      sessionId = Math.random().toString(36).slice(2);
      sessionStorage.setItem("search_session_id", sessionId);
    }

    var lastStoredTerm = "";

    /* ================================
       5️⃣ Firestore write
       ================================ */
    var storeSearchTerm = debounce(function (term) {
      var cleaned = term.trim().toLowerCase();

      if (cleaned.length < 4) return;
      if (cleaned === lastStoredTerm) return;

      lastStoredTerm = cleaned;

      db.collection("search_terms_pawfyuk").add({
        term: cleaned,
        sessionId: sessionId,
        createdAt: firebase.firestore.FieldValue.serverTimestamp()
      }).catch(function (err) {
        console.warn("Search term not saved", err);
      });

    }, 700);

    /* ================================
       6️⃣ Live search + filters
       ================================ */

    var elements = document.querySelectorAll(".pawfy-products li");
    var noResults = document.querySelector(".no-items");
    var filters = document.querySelectorAll(".best-sellers__search-categories li");
    var selectedCategory = "s";
    var dropdown = document.getElementById("dropdown");

    // Category click
    for (var i = 0; i < filters.length; i++) {
      filters[i].addEventListener("click", function (ev) {
        ev.preventDefault();

        dropdown.classList.toggle("active");
        document.querySelector("h3.heading").innerText = this.innerText;

        for (var j = 0; j < filters.length; j++) {
          filters[j].classList.remove("active");
        }
        this.classList.add("active");

        selectedCategory = this.dataset.id.toLowerCase();

        var filterRelated = document.querySelectorAll(
          ".pawfy-products li[data-filter*='" + selectedCategory + "']"
        );

        for (var k = 0; k < elements.length; k++) {
          elements[k].style.display = "none";
        }

        if (filterRelated.length > 0) {
          noResults.style.display = "none";
          for (var l = 0; l < filterRelated.length; l++) {
            filterRelated[l].style.display = "block";
          }
        } else {
          noResults.style.display = "block";
        }
      });
    }

    // Search input
    document.getElementById("searchShop").addEventListener("keyup", function () {

      for (var i = 0; i < elements.length; i++) {
        elements[i].style.display = "none";
      }

      for (var j = 0; j < filters.length; j++) {
        filters[j].classList.remove("active");
      }

      var searchRelated = document.querySelectorAll(
        ".pawfy-products li[data-search*='" + this.value.toLowerCase() + "']"
      );

      if (searchRelated.length > 0) {
        noResults.style.display = "none";
        for (var k = 0; k < searchRelated.length; k++) {
          searchRelated[k].style.display = "block";
        }
      } else {
        noResults.style.display = "block";
      }

      // Reset state
      if (this.value.length === 0) {

        for (var l = 0; l < elements.length; l++) {
          elements[l].style.display = "block";
        }
        noResults.style.display = "none";

        var prevSelected = document.querySelectorAll(
          ".pawfy-products li[data-filter*='" + selectedCategory + "']"
        );

        for (var m = 0; m < prevSelected.length; m++) {
          prevSelected[m].style.display = "block";
        }

        var historySelected = document.querySelector(
          ".best-sellers__search-categories li[data-id*='" + selectedCategory + "']"
        );

        if (historySelected) {
          historySelected.classList.add("active");
          historySelected.click();
        }
      }

      storeSearchTerm(this.value.toLowerCase());
    });

    // Hash-based preselect
    if (window.location.hash) {
      var hashEl = document.querySelector(
        ".best-sellers__search-categories li[data-id*='" +
        window.location.hash.replace("#", "") +
        "']"
      );
      if (hashEl) {
        hashEl.click();
      }
    }

  }

})(); 
